import { Icon, Tag } from '@core/ui-elements'
import { calculateETA } from '@utils/calculations'
import { FC, useMemo } from 'react'
import { MdCircle } from 'react-icons/md'

import { Timer } from '../timer'

export interface IEtaTimer {
  ETAMax?: string
  ETAMin?: string
  initialTime: string | Date
  showHours?: boolean
  hideZeroHours?: boolean
  bgColor?: string
  showIcon?: boolean
}

export const EtaTimer: FC<IEtaTimer> = ({
  ETAMax,
  ETAMin,
  initialTime,
  showHours = false,
  hideZeroHours = true,
  bgColor,
  showIcon = false,
}) => {
  const formatETA = useMemo(() => {
    const { ETAMax: max, ETAMin: min } = calculateETA({
      ETAMax,
      ETAMin,
      initialTime,
    })

    if (!max) {
      return ''
    }

    if (!min) {
      return `ETA ${max}`
    }

    return `ETA ${min}-${max}`
  }, [ETAMax, ETAMin, initialTime])

  return (
    <Tag backgroundColor={bgColor}>
      {formatETA}{' '}
      {(ETAMax || showIcon) && <Icon as={MdCircle} boxSize="0.5rem" />}{' '}
      <Timer
        hideZeroHours={hideZeroHours}
        initialTime={initialTime}
        showHours={showHours}
      />
    </Tag>
  )
}
